import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
  text: {
    type: String,
    default: "Loading...",
  },
  small: {
    type: Boolean,
    default: false,
  },
  fullPage: {
    type: Boolean,
    default: false,
  },
  hideText: {
    type: Boolean,
    default: false,
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY_RED,
      secondaryColor: "rgba(255, 1, 8, 0.2)",
    }),
    required: false,
  },
},
  setup(__props) {

const props = __props



const color = computed(() => {
  return {
    borderTop: `1em solid ${props.theme.secondaryColor}`,
    borderRight: `1em solid ${props.theme.secondaryColor}`,
    borderBottom: `1em solid ${props.theme.secondaryColor}`,
    borderLeft: `1em solid ${props.theme.primaryColor}`,
  }
})

return { __sfc: true,props, color }
}

})